import React, {useContext} from "react";
import {Icon, Space, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext} from "../../../../../../../core/Contexts";
import date from "../../../../../../../core/functions/date";
import currency from "../../../../../../../core/functions/currency";
import envelope from "../../../../../../../images/envelope.svg";

export default React.memo(function Status({
    status,
    activated_at,
    unblock_sum,
    pay_type,
    verification,
    additional_data
}: IProps) {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();

    return (
        <Typography as="div" className="bl-activation-list-items-item-status">
            <Space direction="vertical" size={0}>
                <Space
                    direction="horizontal"
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 10 : 5}
                    align="center"
                    className="status-text"
                >
                    {_.isEqual(pay_type, "super_link") && (
                        <svg width="24" height="24">
                            <use href={"#super_link"} />
                        </svg>
                    )}
                    {_.isEqual(additional_data?.super_link_type, "envelope") && (
                        <img src={envelope} width={29} alt="npsbook" />
                    )}
                    {_.isEqual(status, "activated") && _.isEqual(verification, "done") ? (
                        <>
                            <Icon name="status_active" size="20" />
                            <Typography as="div" color="#fff" size={16}>
                                {t("Активирован")}
                            </Typography>
                        </>
                    ) : _.isEqual(status, "blocked") && _.isEqual(verification, "done") ? (
                        <>
                            <Icon name="status_blocked" size="20" />
                            <Typography as="div" color="#fff" size={16}>
                                {t("Заблокирован")}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <Icon
                                name="status_registration"
                                size={_.gte(contextLayout?.width ?? 0, 376) ? "20" : "14"}
                            />
                            <Typography
                                as="div"
                                color="#fff"
                                size={_.gte(contextLayout?.width ?? 0, 376) ? 16 : 14}
                            >
                                {t("Переоформление")}
                            </Typography>
                        </>
                    )}
                </Space>
                <Typography
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 12 : 12}
                    color="rgba(255, 255, 255, 0.5)"
                    className="status-date"
                >
                    {_.isEqual(status, 1)
                        ? t("Дата активации: {date}", {date: date(activated_at)})
                        : t("Для разблокировки: {sum}", {sum: currency(unblock_sum)})}
                </Typography>
            </Space>
        </Typography>
    );
});

interface IProps {
    status: string | undefined;
    activated_at: string;
    unblock_sum: number;
    pay_type: string;
    verification: string;
    additional_data?: any;
}
